/**
 * Wishlist logic for Shopify Theme (Local Storage)
 */
const WISHLIST_KEY = 'theme_wishlist_items';

window.Wishlist = {
  get: function() {
    try {
      const stored = localStorage.getItem(WISHLIST_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      return [];
    }
  },

  save: function(items) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
      window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items } }));
    } catch (e) {
      console.error('Local storage not supported', e);
    }
  },

  addVariant: function(handle, variantId) {
    const items = this.get();
    const itemStr = handle + '::' + variantId;
    if (!items.includes(itemStr)) {
      items.push(itemStr);
      this.save(items);
    }
  },

  addHandleOnly: function(handle) {
    const items = this.get();
    if (!items.includes(handle)) {
      items.push(handle);
      this.save(items);
    }
  },

  remove: function(itemStr) {
    this.save(this.get().filter(item => item !== itemStr));
  },

  contains: function(itemStr) {
    return this.get().includes(itemStr);
  },

  containsHandle: function(handle) {
    return this.get().some(item => item === handle || item.startsWith(handle + '::'));
  },

  clear: function() {
    this.save([]);
  }
};

// Header sayacı
function updateWishlistBubble(count) {
  document.querySelectorAll('.wishlist-count-bubble').forEach(bubble => {
    const text = bubble.querySelector('.wishlist-count-text');
    if (text) text.textContent = count;
    bubble.style.display = count > 0 ? 'flex' : 'none';
  });
}

// Kalp butonları (tek uygulama)
function updateWishlistButtons() {
  document.querySelectorAll('.heart-btn').forEach(btn => {
    const handle = btn.dataset.productHandle;
    if (!handle) return;
    btn.classList.toggle('is-active', window.Wishlist.containsHandle(handle));
  });
}

// Eski isimlerle çağıran dosyalar bozulmasın:
// - WlmSyncHearts: eski modal kodu
// - initWishlistButtons: related-products.liquid ve recently-viewed.liquid,
//   dinamik yüklenen kartlardan sonra bunu çağırıyor
window.WlmSyncHearts = updateWishlistButtons;
window.initWishlistButtons = updateWishlistButtons;

function initAllWishlistFeatures() {
  updateWishlistBubble(window.Wishlist.get().length);
  updateWishlistButtons();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllWishlistFeatures);
} else {
  initAllWishlistFeatures();
}

window.addEventListener('wishlist:updated', (e) => {
  updateWishlistBubble(e.detail.items.length);
  updateWishlistButtons();
});